import FolderIcon from '@material-ui/icons/Folder';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Link } from '../Link';
import { ExpandCollapseIconButton } from '../ExpandCollapseIconButton';
import { ChevronSlot, DocumentNameCellRoot, DocumentRowIcon } from './styled';
import { OrganizationScopedFolderIcon } from './OrganizationScopedFolderIcon';

const FolderName = styled.span`
  font-weight: 500;
`;

const SlotExpandButton = styled(ExpandCollapseIconButton)`
  && {
    width: 100%;
    min-width: unset;
    height: 1.5rem;
    min-height: unset;
    padding: 0;
  }
`;

interface FolderNameCellProps {
  name: string;
  to: string;
  isExpandable: boolean;
  isExpanded: boolean;
  onToggleExpand: () => void;
  showOrganizationScopedIcon?: boolean;
  showChevronSlot?: boolean;
}

// We don't want to prevent the default behavior of the link when the user clicks on it
// with a non-primary button or a modifier key (e.g. shift, ctrl, alt, etc.).
function isUnmodifiedPrimaryClick(event: React.MouseEvent) {
  return (
    event.detail !== 0 &&
    !event.metaKey &&
    !event.ctrlKey &&
    !event.shiftKey &&
    !event.altKey &&
    event.button === 0
  );
}

export function FolderNameCell({
  name,
  to,
  isExpandable,
  isExpanded,
  onToggleExpand,
  showOrganizationScopedIcon = false,
  showChevronSlot = true,
}: FolderNameCellProps) {
  const navigate = useNavigate();

  return (
    <DocumentNameCellRoot>
      {showChevronSlot && (
        <ChevronSlot>
          {isExpandable ? (
            <SlotExpandButton
              isExpanded={isExpanded}
              onClick={(event) => {
                event.stopPropagation();
                onToggleExpand();
              }}
            />
          ) : null}
        </ChevronSlot>
      )}
      <DocumentRowIcon $variant="folder">
        <FolderIcon titleAccess="Folder" />
      </DocumentRowIcon>
      <FolderName>
        {isExpandable ? (
          <Link
            to={to}
            color="grey"
            draggable={false}
            onClick={(event) => {
              if (isUnmodifiedPrimaryClick(event)) event.preventDefault();
            }}
            onDoubleClick={(event) => {
              if (!isUnmodifiedPrimaryClick(event)) return;
              event.preventDefault();
              navigate(to);
            }}
          >
            {name}
          </Link>
        ) : (
          name
        )}
      </FolderName>
      {showOrganizationScopedIcon && <OrganizationScopedFolderIcon />}
    </DocumentNameCellRoot>
  );
}
